/**
 * Tabs
 */

export default function Tabs() {
    const selectors = {
        'tabs' : '.js-tabs',
        'tab' : '.tab-name',
        'content' : '.tab-content',
        'breakpoint' : 1024,
    };

    this.init = () => {
        this.handle();
    };

    this.move2Tab = ($tab, $parent) => {
        $parent.find(`.tab-content[data-tab="${$tab}"]`).removeClass('hidden').siblings().addClass('hidden');
    }

    this.handleTab = () => {
        jQuery(selectors.tabs).on('click', selectors.tab, (e) => {
            e.preventDefault();
            const $this = jQuery(e.target);
            let $tab = $this.data("tab");
            let $parent = $this.closest(selectors.tabs);
            $this.addClass('active').siblings().removeClass('active');
            this.move2Tab($tab, $parent);
        })
    }

    this.handleSlider = () => {
        if(jQuery(window).width() <= selectors.breakpoint){
            jQuery(selectors.tabs).find('.tab-names-wrapper').slick({
                dots: false,
                arrows: true,
                infinite: false,
                adaptiveHeight: true,
                speed: 300,
            }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                let $tab = slick.$slider.find(`${selectors.tab}[data-slick-index="${nextSlide}"]`).data("tab");
                let $parent = slick.$slider.closest(selectors.tabs);
                this.move2Tab($tab, $parent);
            });
        }

    }

    this.handle = () => {
        this.handleTab();
        this.handleSlider();
        let windowSize = jQuery(window).width();
        jQuery(window).on('resize', () => {
            if(windowSize != jQuery(window).width()){
                let slickWrapper = jQuery(selectors.tabs).find('.tab-names-wrapper');
                if(jQuery(window).width() > selectors.breakpoint){
                    if(slickWrapper.hasClass('slick-initialized')){
                        slickWrapper.slick('unslick');
                    }
                }else{
                    if(!slickWrapper.hasClass('slick-initialized')){
                        this.handleSlider();
                    }
                }
            }
        })
    }


}
